<template>
  <div class="main">
    <van-notice-bar
      left-icon="info-o"
      :scrollable="false"
      background="#F222221A"
      text="注:每月15日前完成提交，有异议请在群里找王海苑。"/>
    <div style="padding: 0 12px;">
      <div class="div_flex_between">
        <div style="font-weight: 600;" @click="showPicker = true">
          <van-icon name="calendar-o" style="font-weight: 600;"/>
          {{ DateTime }}
          <van-icon name="arrow-down" style="font-weight: 600;font-size: 12px;"/>
        </div>
        <div style="color: #999999;font-size: 14px;">{{form.Total ? '数据更新至'+form.CreateTime : '数据待更新'}}</div>
      </div>
      <div class="div_flex_between div_card">
        <div>
          <div><van-icon name="gold-coin-o" />合计费用(元)</div>
          <div class="total">{{ form.Total }}</div>
        </div>
        <div>
          <div>早班拼车(元)</div>
          <div class="total">{{ form.ztotal }}</div>
        </div>
        <div>
          <div>晚班拼车(元)</div>
          <div class="total">{{ form.wtotal }}</div>
        </div>
      </div>
      <van-tabs v-model="active" color="#FEB013" animated>
        <van-tab title="早班" :style="'height:'+ListHeight+'px;overflow-y: auto;'">
          <div class="div_flex_between" v-for="(item, key) in Zlist" :key="key" style="border-bottom: 1px double #f5f5f5;padding: 12px;">
            <div>{{ key+1 }}</div>
            <div>{{ item.DateTime }}</div>
            <div>{{ item.PName }}</div>
            <div>{{ item.Effect === false ? '无效' : '有效' }}</div>
          </div>
        </van-tab>
        <van-tab title="晚班" :style="'height:'+ListHeight+'px;overflow-y: auto;'">
          <div class="div_flex_between" v-for="(item, key) in Wlist" :key="key" style="border-bottom: 1px double #f5f5f5;padding: 12px;">
            <div>{{ key+1 }}</div>
            <div>{{ item.DateTime }}</div>
            <div>{{ item.Name }}</div>
            <div>{{ item.Effect === false ? '无效' : '有效' }}</div>
          </div>
        </van-tab>
      </van-tabs>
      <div style="margin: 12px 0;">
        <van-button v-show="!form.Status" :loading="btnlading" type="primary" block color="black" round  @click="onSubmit">确认无误并提交</van-button>
      </div>
      
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        type="year-month"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        Total: 0,
        ztotal: 0,
        wtotal: 0,
        Status: false
      },
      minDate: new Date('2023-03-01'),
      maxDate: new Date(),
      DateTime: this.$route.query.date ? this.$route.query.date : this.$moment().subtract(1,'months').format('YYYY-MM'),
      showPicker: false,
      active: 0,
      loading: false,
      finished: false,
      Zlist: [],
      Wlist: [],
      ListHeight: window.innerHeight,
      btnlading: false
    }
  },
  mounted() {
    // const test = {"errno":0,"data":{"errcode":0,"errmsg":"ok","userid":"2017551","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // this.WXInfo = test.data

    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
    this.getData()
  },
  methods: {
    getData() {
      this.getOrder()
      this.getWorkTravelList()
      this.getTravelList()
    },
    async onSubmit() {
      this.btnlading = true
      const result = await this.putSaveData()
      if (result.success) {
        this.$toast('提交成功')
        this.getData()
      } else {
        this.$toast(result.message)
      }
      setTimeout(()=> {this.btnlading = false},1000)
    },
    onConfirm(value) {
      this.DateTime = this.$moment(value).format('YYYY-MM')
      this.getData()
      this.showPicker = false
    },
    async getOrder() {
      const result = await this.$request({
        url: '/api/order/getOrderList',
        method: 'GET',
        params: {
          DateTime: this.DateTime,
          UserId: this.WXInfo.userid
        }
      })
      if (result.data.length) {
        let item = result.data[0]
        this.form.Total = item.Total
        this.form.ztotal = item.ztotal
        this.form.wtotal = item.wtotal
        this.form.Status = item.Status
        this.form.CreateTime = item.CreateTime
      } else {
        this.form.Total = 0
        this.form.ztotal = 0
        this.form.wtotal = 0
        this.form.Status = true
      }
      if (this.form.Status) {
        this.ListHeight = window.innerHeight - 230
      } else {
        this.ListHeight = window.innerHeight - 290
      }
    },
    async getWorkTravelList() {
      const result = await this.$request({
        url: '/api/GoWork/getWorkTravelList',
        method: 'GET',
        params: {
          DriverId: this.WXInfo.userid,
          startTime: this.DateTime + '-01',
          endTime: this.DateTime + '-31'
        }
      })
      this.Zlist = result.data
      this.loading = false;
    },
    async getTravelList() {
      const result = await this.$request({
        url: '/api/Commute/getTravelList',
        method: 'GET',
        params: {
          DriverId: this.WXInfo.userid,
          startTime: this.DateTime + '-01',
          endTime: this.DateTime + '-31'
        }
      })
      this.Wlist = result.data
      this.loading = false;
    },
    putSaveData() {
      return this.$request({
        url: '/api/order/postOrderData',
        method: 'POST',
        params: {
          UserId: this.WXInfo.userid,
          DateTime: this.DateTime
        },
        data: {
          Status: true
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .main {
    height: inherit;
    background-color:#FFFFFF;
  }
  .div_flex_between {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
  }
  .div_card {
    background: #FEB013;
    background-image: url('../../assets/mincar.svg');
    background-repeat: no-repeat;
    background-position: right;
    background-size: 120px;
    border-radius: 4px;
    color: white;
    text-align: center;
    box-shadow: 0px 3px 12px 0px rgba(252, 113, 39, 0.30);
    padding: 12px;
    font-size: 14px;
  }
  .total {
    font-size: 30px;
    font-weight: 600;
    padding-top: 12px;
  }
</style>
